import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Registering Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1JAaF5cX2pCeUx0Qnxbf1x2ZFRHallYTnRfUj0eQnxTdENjXn1ccndQT2JcVUB0X0leZw==');


if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
